module.exports = __webpack_public_path__ + "static/media/Feedsoltuion.68a00876.jpeg";